module.exports = __webpack_public_path__ + "6c3b9310dbd5e9d3851e647fa18e530f.pdf";